const request = require('request');
const config = require('./config');

var getEtiquetas = (token,page,limit) => {
  return new Promise((resolve,reject) => {
    request({
        headers: {
          'Content-Type': 'application/json',
          'User-Token': token
        },
        uri: config.URL_BACKEND+'/etiquetas?page='+page+'&limit='+limit,
        method: 'GET'
      }, (err, res, body) => {
        if (err) return reject(err);
        resolve(body)
      })
  })
}

module.exports = {
    getEtiquetas:getEtiquetas
}